import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  button,
  TextField,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { PlusCircle, Edit2 } from "lucide-react";
import {
  fetchHrProfilesService,
  addHrProfileService,
  updateHrProfileService,
  deleteHrProfileService,
} from '../../Services/hrProfiles.service';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useMediaQuery } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { Edit, Delete, EditOutlined, DeleteOutlined } from "@mui/icons-material";
import Loader from "../Loader";
import ConfirmationDialog from "../shared_components/ConfirmationDialog";
import { useTheme } from "../../hooks/useTheme";
import LimitExceededModal from "../shared_components/LimitExceededModal";
import { useSelector } from "react-redux";

const HrProfile = () => {
  const [hrProfiles, setHrProfiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedHrId, setSelectedHrId] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 1100px)");
  const [limitModal, setLimitModal] = useState({ open: false, featureKey: null });
  const org_id = useSelector((state)=>state.userSlice.org_id);

  const {theme} = useTheme();


  const fetchHrProfiles = async () => {
    try {
      setIsLoading(true);
      const data = await fetchHrProfilesService();
      setHrProfiles(data);
    } catch (error) {
      console.error("Error fetching HR profiles:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrProfiles();
  }, []);

  const handleAddHR = () => {
  // setModalTitle("Add Recruiter");

  const darkInputStyles = {
    "& .MuiOutlinedInput-input": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiInputLabel-root": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
      "&:hover fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
    },
  };

  setModalContent(
  <div>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 16px",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          // fontWeight: 600,
          fontSize: "1.2rem",
          color: theme === "dark" ? "white" : "#000",
        }}
      >
        Add Recruiter
      </Typography>

      <IconButton
        aria-label="close"
        onClick={() => setShowModal(false)}
        sx={{
          color: theme === "dark" ? "white" : "#525252",
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>

    <form onSubmit={handleAddHRSubmit} style={{ padding: "0 16px 16px" }}>
      <TextField
        label="Name"
        name="name"
        required
        fullWidth
        margin="normal"
        variant="outlined"
        className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
        sx={theme === "dark" ? darkInputStyles : {}}
      />

      <TextField
        label="Email"
        name="email"
        type="email"
        required
        fullWidth
        margin="normal"
        variant="outlined"
        className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
        sx={theme === "dark" ? darkInputStyles : {}}
      />

      <TextField
        label="Contact Number"
        name="contactNumber"
        required
        fullWidth
        margin="normal"
        variant="outlined"
        className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
        sx={theme === "dark" ? darkInputStyles : {}}
      />

      <TextField
        label="Department"
        name="department"
        required
        fullWidth
        margin="normal"
        variant="outlined"
        className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
        sx={theme === "dark" ? darkInputStyles : {}}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 16,
        }}
      >
        <button className="button" type="submit" disabled={isSubmitting}>
          <span className="flex items-center gap-2">
            {isSubmitting && (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
              </svg>
            )}
            Save Changes
          </span>
        </button>
      </div>
    </form>
  </div>
);


setShowModal(true);

};


  const handleDeleteConfirmation = (hrId) => {
    setSelectedHrId(hrId);
    setShowConfirmDialog(true);
  };

  const darkInputStyles = {
    "& .MuiOutlinedInput-input": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiInputLabel-root": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "rgb(209, 213, 219)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
      "&:hover fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgb(209, 213, 219)",
      },
    },
  };

  const handleEditHR = (hrProfile) => {
    setModalContent(
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 16px",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              // fontWeight: 600,
              fontSize: "1.2rem",
              color: theme === "dark" ? "white" : "#000",
            }}
          >
            Edit Recruiter Details
          </Typography>

          <IconButton
            aria-label="close"
            onClick={() => setShowModal(false)}
            sx={{
              color: theme === "dark" ? "white" : "#525252",
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        {/* Form */}
        <form
          onSubmit={(event) =>
            handleEditHRSubmit(event, hrProfile.hrId)
          }
          style={{ padding: "0 16px 16px" }}
        >
          <TextField
            label="Name"
            name="name"
            defaultValue={hrProfile.hrName}
            required
            fullWidth
            margin="normal"
            variant="outlined"
            className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
            sx={theme === "dark" ? darkInputStyles : {}}
          />

          <TextField
            label="Email"
            name="email"
            type="email"
            defaultValue={hrProfile.hremail}
            required
            fullWidth
            margin="normal"
            variant="outlined"
            className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
            sx={theme === "dark" ? darkInputStyles : {}}
          />

          <TextField
            label="Contact Number"
            name="contactNumber"
            defaultValue={hrProfile.contactNumber}
            required
            fullWidth
            margin="normal"
            variant="outlined"
            className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
            sx={theme === "dark" ? darkInputStyles : {}}
          />

          <TextField
            label="Department"
            name="department"
            defaultValue={hrProfile.HRDepartment}
            required
            fullWidth
            margin="normal"
            variant="outlined"
            className={`${theme !== "dark" ? "bg-bgSecondary text-textPrimary" : ""}`}
            sx={theme === "dark" ? darkInputStyles : {}}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            <button className="button" type="submit">
              <span>Update</span>
            </button>
          </div>
        </form>
      </div>
    );

    setShowModal(true);
  };

  const handleDeleteHR = async (preserveData) => {
    try {
      setIsLoading(true);
      await deleteHrProfileService(selectedHrId, preserveData);
      toast.success("Recruiter profile Deleted successfully");
      await fetchHrProfiles();
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(`${detail || "Error deleting Recruiter profile"}`);
      if (detail && detail.includes("User not found in Cognito")) {
        await fetchHrProfiles();
      }
    } finally {
      setIsLoading(false);
      setShowConfirmDialog(false);
      setSelectedHrId(null);
    }
  };

  const handleAddHRSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const newHR = {
      hrName: formData.get("name"),
      hremail: formData.get("email"),
      contactNumber: formData.get("contactNumber"),
      HRDepartment: formData.get("department"),
      org_id: org_id,
    };
    try {
      setIsSubmitting(true);
      await addHrProfileService(newHR);
      toast.success(`Recruiter profile added successfully!`);
      setShowModal(false);
      await fetchHrProfiles();
    } catch (error) {
      if (error.response?.status === 403) {
        const detail = error.response.data?.detail;
        const featureKey = typeof detail === "object" ? detail.feature_key : "hr_creation_enabled";
        const errorCode = typeof detail === "string" ? detail : detail?.error_code ?? null;
        setLimitModal({ open: true, featureKey, errorCode });
      } else {
        const detail = error.response?.data?.detail;
        toast.error(`${detail || error.message || "Unknown error"}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleEditHRSubmit = async (event, hrId) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const updatedHR = {
      hrName: formData.get("name"),
      hremail: formData.get("email"),
      contactNumber: formData.get("contactNumber"),
      HRDepartment: formData.get("department"),
    };
    try {
      await updateHrProfileService(hrId, updatedHR);
      alert("Recruiter Profile Updated Successfully");
      setShowModal(false);
      await fetchHrProfiles();
    } catch (error) {
      console.error("Error updating Recruiter profile:", error);
    }
  };
  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="min-h-screen flex flex-col border rounded-2xl border-gray-700/50 dark:glass-effect bg-bgSecondary">
        <div className="table-container flex-1 w-full">
          <div className="table-header px-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 py-4 mb-4">
              <h1 className="text-xl dark:text-[#D9D9D9] text-textPrimary font-normal text-left pl-6">
                Recruiter Profiles
              </h1>
              <button className="button flex items-center justify-center gap-2" onClick={handleAddHR}>
                <span className="flex items-center gap-2 whitespace-nowrap">
                  <PlusCircle className="w-5 h-5" />
                  Add Recruiter
                </span>
              </button>
            </div>

            <div className="w-full overflow-hidden flex flex-col flex-1 min-h-0">
              <div className="w-full flex-1 overflow-y-auto pb-32 min-h-[400px]">
                <Table
                  className="w-full"
                  style={{ transform: 'translateZ(0)', contain: 'layout' }}
                >
                  <Thead className="border-b border-t border-[#5A4479D4]">
                    <Tr>
                      <Th className="text-left min-w-0">
                        <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                          Recruiter Name
                        </span>
                      </Th>
                      <Th className="text-left min-w-0">
                        <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                          Email
                        </span>
                      </Th>
                      <Th className="text-left min-w-0">
                        <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                          Contact
                        </span>
                      </Th>
                      <Th className="text-left min-w-0">
                        <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                          Department
                        </span>
                      </Th>
                      <Th className="text-left min-w-0">
                        <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                          Actions
                        </span>
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {hrProfiles.length === 0 && (
                      <Tr>
                        <Td colSpan={5}>
                          <div className="flex h-60 items-center justify-center">
                            <div className="flex flex-col items-center text-center">
                              <h2 className="text-lg font-medium text-gray-400 mb-1">
                                No Recruiter profiles found
                              </h2>
                              <p className="text-sm text-gray-400">
                                Add a recruiter to get started.
                              </p>
                            </div>
                          </div>
                        </Td>
                      </Tr>
                    )}
                    {hrProfiles.map((hr) => (
                      <Tr
                        key={hr.hrId}
                        className="group dark:hover:bg-gray-700/20 hover:bg-gray-300/20"
                      >
                        <Td className="text-left px-2 py-3 min-w-0">
                          <div className="whitespace-normal break-words text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                            {hr.hrName}
                          </div>
                        </Td>
                        <Td className="text-left px-2 py-3 min-w-0">
                          <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                            {hr.hremail}
                          </div>
                        </Td>
                        <Td className="text-left px-2 py-3 min-w-0">
                          <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                            {hr.contactNumber}
                          </div>
                        </Td>
                        <Td className="text-left px-2 py-3 min-w-0">
                          <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                            {hr.HRDepartment}
                          </div>
                        </Td>
                        <Td className="text-left px-2 py-3 min-w-0">
                          <div className="flex gap-2 items-center px-2">
                            <button
                              className="p-2 rounded-full focus:outline-none group transition-all duration-200 relative"
                              onClick={() => handleEditHR(hr)}
                            >
                              <EditOutlined className="w-4 h-4 transition-opacity duration-200 group-hover:opacity-0" />
                              <Edit className="w-4 h-4 transition-opacity duration-200 opacity-0 group-hover:opacity-100 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                            </button>
                            <button
                              className="p-2 rounded-full focus:outline-none group transition-all duration-200 relative"
                              onClick={() => handleDeleteConfirmation(hr.hrId)}
                            >
                              <DeleteOutlined className="w-4 h-4 text-red-400 transition-opacity duration-200 group-hover:opacity-0" />
                              <Delete className="w-4 h-4 text-red-400 transition-opacity duration-200 opacity-0 group-hover:opacity-100 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                            </button>
                          </div>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>

        <Dialog
          PaperProps={{
            sx: {
              background: `${theme === 'dark' ? "linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))" : ""}`,
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
              borderRadius: "10px",
            },
          }}
          open={showModal}
          onClose={() => setShowModal(false)}
        >
          <DialogTitle>
            <Typography variant="h6" className="dark:text-gray-300 text-textPrimary">
              {modalTitle}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography className="dark:text-gray-300 text-textPrimary">{modalContent}</Typography>
          </DialogContent>
        </Dialog>

        <ConfirmationDialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          title="Delete Recruiter"
          message="Do you want to preserve the candidate data associated with this Recruiter?"
          confirmText="Delete"
          cancelText="Cancel"
          onConfirm={() => handleDeleteHR(false)}
        />
      </div>
      <LimitExceededModal
        isOpen={limitModal.open}
        onClose={() => setLimitModal({ open: false, featureKey: null })}
        featureKey={limitModal.featureKey}
        errorCode={limitModal.errorCode}
      />
    </>
  );

};
export default HrProfile;
